import { Component } from '@angular/core';

@Component({
  selector: 'subs-form-content',
  template: `
    <ng-content></ng-content>
  `,
})
export class ContentAreaComponent {}
